import { render, staticRenderFns } from "./employeeDetail.vue?vue&type=template&id=6a2f23fa&scoped=true"
import script from "./employeeDetail.vue?vue&type=script&lang=js"
export * from "./employeeDetail.vue?vue&type=script&lang=js"
import style0 from "./employeeDetail.vue?vue&type=style&index=0&id=6a2f23fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f23fa",
  null
  
)

export default component.exports